import * as React from "react";
const SvgLargeX = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-8765ef35-43b6-47ce-9af2-48af36e3b3de", "data-name": "uuid-540ba4a6-0f04-491d-bed1-71524a84da7e", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 4.6, y1: 4.6, x2: 19.4, y2: 19.4, style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: "1.3px"
} }), /* @__PURE__ */ React.createElement("line", { x1: 19.4, y1: 4.6, x2: 4.6, y2: 19.4, style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: "1.3px"
} }));
export default SvgLargeX;
